import { Component, Input, OnInit, ChangeDetectorRef, OnChanges, EventEmitter, ViewChild, Output, LOCALE_ID } from '@angular/core';
import { FormGroup, ValidationErrors, FormArray, FormControl } from '@angular/forms';
import { AtylService} from '../../../../service/atyl.service';

import { FormAtylBase } from '../../../../form-atyl-base';

import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material';

import {map, startWith,tap} from 'rxjs/operators';
 
@Component({
  selector: 'atyl-form-input-place',
  templateUrl: './form-input-place.component.html',
  styleUrls: ['./form-input-place.component.scss'],
})
export class FormInputPlaceComponent implements OnInit, OnChanges {
  myControl = new FormControl();
  myControl2 = new FormControl();
  @Input() forminput: FormAtylBase<any>;
  @Input() form: FormGroup;
  @Input() group: any
  @Input() outline: any
  @Input() isValid: boolean
  @Input() errorMessage: any
  @Output() inputTyped = new EventEmitter<any>();
  @Input() disabled: boolean
  
  listGeoType:any[]=[];
  listGeo:any[]=[];

	filteredOptions:Observable<any[]>;
	filteredGeoOptions: Observable<any[]>;
  constructor (
    private atylService : AtylService,
    private cdr : ChangeDetectorRef,
    private dialog: MatDialog, 
  ){}
  
  ngOnInit() {
	  
	  
	console.log("FormInputPlaceComponent init",this.forminput);
    this.getZoneType();
    
    
    
  }

  ngOnChanges() {
	  console.log("ngOnChanges before",this.forminput)
    if(this.forminput && this.forminput.type == "place"){
	console.log("ngOnChanges",this.forminput)
     if(this.forminput.value)
      {
		  	console.log("ngOnChanges value",this.forminput.value)
		  let grp:FormGroup= this.group.get(this.forminput.ID)  as FormGroup;
		Object.keys(this.forminput.value).forEach((key:string) => 
				{
				let val:any=this.forminput.value[key];
		
				 console.log("ngOnChanges value contole bedfore",key,val)
				 if (grp.controls[key]!=undefined) {
					 console.log("ngOnChanges value contole",grp.controls[key],val)
				 	grp.controls[key].setValue(val);
				 	}
			 	}
			) ;
      /*  if(this.forminput.value["code"])
          codepost = this.forminput.value["code"]
        if(this.forminput.value["ville"])
          ville = this.forminput.value["ville"]
        if(this.forminput.value["adresse"])
          this.group.get(this.forminput.ID).get("adresse").setValue(this.forminput.value["adresse"].toUpperCase());
		
          		
*/
      }
      
    }
  }

  getZoneType() {
	  this.atylService.getGeoType().subscribe((result) => {
		  if (result.result!=undefined) {
		  	this.listGeoType=result.result;
		  	let nozone:boolean=false;
		  	let defaultV:any=(this.listGeoType.length>0) ? this.listGeoType[0].ID : null;
		  	 if(this.forminput.value && this.forminput.value["geotype"]!=undefined){
				 let grp:FormGroup= this.group.get(this.forminput.ID)  as FormGroup;
				  grp.controls["geotype"].setValue(this.forminput.value["geotype"]);
				  this.getZone(this.forminput.value["geotype"]);
				  nozone=true;
				  
			}
		  	if ( ! nozone
				&&  this.listGeoType.length>0
		  	&& this.listGeoType[0].ID!=undefined
		  	&& this.listGeoType[0].ID.length>0
		  	)
		  	  this.getZone(this.listGeoType[0].ID);
		  		
		  	this.filteredOptions = this.myControl.valueChanges.pipe(
		      startWith(''),
		      map(value => typeof value === 'string' ? value : value.ID),
        	  map(name => name ? this._filter(name) : this.listGeoType.slice()),
		      /*tap(() => this.myControl.setValue(defaultV))*/
		     
		    );
		    
		    
		    
			this.cdr.detectChanges();
		  }
	 });
  }
  
   getZone(type:string) {
	  this.listGeo=[];
	  this.atylService.getGeo(type).subscribe((result) => {
		  if (result.result!=undefined) {
		  	this.listGeo=result.result;
		  	let defaultV:any=(this.listGeo.length>0) ? this.listGeo[0].ID : null;
		  	if(this.forminput.value && this.forminput.value["geo"]!=undefined){
				  let grp:FormGroup= this.group.get(this.forminput.ID)  as FormGroup;
				  grp.controls["geo"].setValue(this.forminput.value["geo"]);
				  defaultV=this.forminput.value["geo"];
				  
			}
		  	this.filteredGeoOptions = this.myControl2.valueChanges.pipe(
		      startWith(''),
		      map(value => typeof value === 'string' ? value : value.ID),
        	  map(name => name ? this._filterGeo(name) : this.listGeo.slice()),
		     /* tap(() => this.myControl2.setValue(defaultV))*/
		      
		     
		    );
		  	
		  	
		  	this.cdr.detectChanges();
		  }
	 });
  }
  
  onDepartementChange(event:any) {
	  console.log("onDepartementChange",event)
	  this.getZone(event.option.value);
	  this.getGeoType(event.option.value);
  }
  
 private _filter(value: string): any[] {
 	   const filterValue = value.toLowerCase();
   //   console.log("_filter",filterValue,this.listGeoType)
     // return this.listGeoType;
   return this.listGeoType.filter(option => ((option.ID.toLowerCase().includes(filterValue))
   								|| (option.libelle.toLowerCase().includes(filterValue))
   								)
   								)
   ;
  }
  
  displayFn(value:any): string {
	  console.log("displayFn", value);
    return value;
  }
  
  private _filterGeo(value: string): any[] {
 	   const filterValue = value.toLowerCase();
    // console.log("_filter",filterValue,this.listGeo)
     // return this.listGeoType;
   return this.listGeo.filter(option => ((option.ID.toLowerCase().includes(filterValue))
   								|| (option.libelle.toLowerCase().includes(filterValue)))
   								)
   ;
  }
  
  displayGeoFn(value:any): string {
    return value;
  }
  
  getGeoType(value:any) {
	 let grp:FormGroup= this.group.get(this.forminput.ID)  as FormGroup;
	  console.log("getGeoType",value,grp, grp.controls);
	  grp.controls["geotype"].setValue(value);
	   grp.controls["geo"].setValue("");
	  
      
  }
  
  getGeo(value:any) {
	  
	   (this.group.get(this.forminput.ID) as FormGroup).controls["geo"].setValue(value);
	 
      
  }
  
 displayAutoDep(depid?: any): string | undefined {
	console.log("displayAutoDep",depid,this.filteredOptions);
    let depselected:any;
    if(this.filteredOptions){
      this.filteredOptions.forEach((deps) => {
		 console.log("displayAutoDep foreach",deps);
		deps.forEach((dep)=>{
			if(dep.ID === depid)
        		depselected = dep;
		}) 
        
      });
    }
    console.log("displayAutoDep",depid,depselected);
	let geolib:string=undefined;
		
		if (depselected) {
			geolib=depselected.libelle;
			
			if (depselected.ID && depselected.ID!='')
				geolib+=" (INSEE: "+depselected.ID+")";
		}
    return geolib;
	
   // return depselected ? depselected.libelle+ " ("+depselected.ID+")" : undefined;
  }
  
  displayAutoGeo(geoid?: any): string | undefined {
	console.log("displayAutoDep",geoid,this.filteredGeoOptions);
    let depselected:any;
    if(this.filteredGeoOptions){
      this.filteredGeoOptions.forEach((deps) => {
		 console.log("displayAutoDep foreach",deps);
		deps.forEach((dep)=>{
			if(dep.ID === geoid)
        		depselected = dep;
		}) 
        
      });
    }
    console.log("displayAutoGeo",geoid,depselected);
	
	let geolib:string=undefined;
	
	if (depselected) {
		geolib=depselected.libelle;
		
		if (depselected.ID && depselected.ID!='')
			geolib+=" (INSEE: "+depselected.ID+")";
	}
	return geolib;
   // return depselected ? depselected.libelle+ " (INSEE: "+depselected.ID+")" : undefined;
  }
  
  

}